import React from "react";

/**
 * IconImage Component
 * Replaces emojis with image files
 * 
 * Usage:
 * <IconImage name="robot" size={20} alt="Robot icon" />
 * 
 * Place your images in: public/images/icons/
 * Supported formats: .png, .svg, .jpg
 */
function IconImage({ name, size = 20, alt = "", className = "", style = {} }) {
  const imagePath = `/images/icons/${name}.png`; // Default to PNG, you can change to .svg or .jpg
  
  return (
    <img
      src={imagePath}
      alt={alt || name}
      width={size}
      height={size}
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        ...style,
      }}
      className={className}
      onError={(e) => {
        // Fallback to emoji if image doesn't exist
        console.warn(`Image not found: ${imagePath}, falling back to emoji`);
        e.target.style.display = "none";
      }}
    />
  );
}

export default IconImage;
